import { STORE_SERVICES } from '../../../../../views/phone-answering/constants';

export default {
  title: 'Servicios',
  options: {
    [STORE_SERVICES.CATERING]: 'Catering',
    [STORE_SERVICES.TERRACE]: 'Terraza disponible',
    [STORE_SERVICES.DINE_IN]: 'Comer en el local',
    [STORE_SERVICES.ONLINE_ORDERING]: 'Pedidos en línea vía Foodamigos',
    [STORE_SERVICES.RESERVATION]: 'Reservas vía Foodamigos',
    [STORE_SERVICES.INTERNAL_RESERVATION]: 'Reservas en el restaurante',
  },
  labels: {
    reservation_total_seats: 'Aforo total para reservas',
    catering_min_people: 'Personas mínimas para catering',
  },
};
